var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change"},[_c('BasePriority',{staticClass:"change__item old",attrs:{"level":_vm.change.info.old}}),_c('BasePriority',{staticClass:"change__item",attrs:{"level":_vm.change.info.new}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }